// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3x5ib","inputWrap":"CustomTip_inputWrap__Mgxym"};